import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-bb61a298"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "label"
}
const _hoisted_2 = { class: "textbox-container" }

import { PropType, computed, ref } from "vue";
import { DxValidator } from "devextreme-vue";
import { DxTextArea } from "devextreme-vue";
import { DxRequiredRule } from "devextreme-vue/validator";
import { FieldSize } from "@/enums/system/FieldSize";
import { ValidatedEvent } from "devextreme/ui/validator";
import { TextboxValueChangeEvent } from "@/enums/ui/inputs/TextboxValueChangeEvent";


export default /*#__PURE__*/_defineComponent({
  __name: 'field-validation-free-text-area',
  props: {
  /**
   * The string value used with `v-model` to control the visibility or state of a modal or component.
   * @type {string}
   * @required
   */
  modelValue: {
    type: String,
    required: true,
  },
  /**
   * The height of the component, specified as a CSS string.
   * @type {string}
   * @default '9rem'
   */
  height: {
    type: String,
    default: "9rem",
  },
  /**
   * The width of the input field, defined by `FieldSize`.
   * @type {FieldSize}
   * @default FieldSize.Full
   */
  width: {
    type: String as PropType<FieldSize>,
    default: FieldSize.Full,
  },
  /**
   * Determines whether the specific control is read only.
   * @type {boolean}
   * @default false
   */
  readOnly: {
    type: Boolean,
    default: false,
  },
  /**
   * The label displayed for the control.
   * @type {String}
   * @default ''
   */
  label: {
    type: String,
    default: "",
  },
  /**
   * Determines whether the control is required.
   * @type {boolean}
   * @default false
   */
  isRequired: {
    type: Boolean,
    default: false,
  },
  /**
   * The numeric value indicating the selected option for housing development.
   * @type {number}
   * @default -1
   */
  valueChangeEvent: {
    type: String as PropType<TextboxValueChangeEvent>,
    default: TextboxValueChangeEvent.Change,
  },
},
  emits: [
  "update:modelValue",
  "onValueChanged",
  "onInitialised",
],
  setup(__props, { emit }) {

const props = __props;



const value = computed({
  get: () => props.modelValue,
  set: (val: string) => emit("update:modelValue", val),
});



/** Custom validation configuration to override DevExpress default validation method */
const adapterConfig = {
  getValue: () => {
    return value.value;
  },
  applyValidationResults: (e: ValidatedEvent) => {
    isValid.value = !!e.isValid;

    // Construct list of validation errors to be displayed to the user when they hover over the field
    validationErrors.value =
      !e.isValid && e.brokenRule?.message ? e.brokenRule.message : "";
  },
  validationRequestsCallbacks: [],
};

const validationErrors = ref("");
const isValid = ref(true);

const onFocusOut = () => (value.value = value.value.trim());

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (__props.label)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(__props.label), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(DxTextArea), {
        value: value.value,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((value).value = $event)),
        height: __props.height,
        width: __props.width,
        "read-only": props.readOnly,
        "is-valid": isValid.value,
        hint: validationErrors.value,
        valueChangeEvent: __props.valueChangeEvent,
        onFocusOut: onFocusOut
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(DxValidator), { adapter: adapterConfig }, {
            default: _withCtx(() => [
              (props.isRequired)
                ? (_openBlock(), _createBlock(_unref(DxRequiredRule), { key: 0 }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["value", "height", "width", "read-only", "is-valid", "hint", "valueChangeEvent"])
    ])
  ], 64))
}
}

})